export const ItemTypes={
    ROTATION:'rotation',
    CARD:'card',
    LIEU:'lieu',
    ACTE:'acte',
    NEWS:'news'
}